module.exports = __webpack_public_path__ + "static/media/waypoint_m.47ccc3c5.svg";